import logoWordmark from "@/assets/sparkd-wordmark-light.png";
import logoIcon from "@/assets/sparkd-flame.png";

export const TAGLINE = "Real People, Real Vibes, Real Connection";

export const BrandWordmark = ({ className = "h-9 w-auto" }) => (
  <img src={logoWordmark} alt="Sparkd" className={className} draggable={false} />
);

export const BrandIcon = ({ className = "h-9 w-auto object-contain" }) => (
  <img src={logoIcon} alt="Sparkd" className={className} draggable={false} />
);
